<template>
  <div class="about">
    <section class="about__banner">
      <div class="about__banner--img"></div>
      <div class="about__banner--inner">
        <div class="about-info">
          <div class="about-info__title">
            <p class="about-info__title--first">Optimum Blockchain <br />Metaverse Platform</p>
            <p class="about-info__title--sub">
              MEVerse, with its lightning-fast speed and low fees, is the most optimum platform for Metaverse covering Entertainment, P2E games, DeFi, NFT, and others.
            </p>
          </div>
          <div class="about-info__content">
            <div class="block block-height">
              <div class="block__number">
                <ICountUp :endVal="initBlockNumber" :options="options" @ready="blockHeightReady" />
              </div>
              <span class="block__title">Block Height</span>
            </div>
            <div class="block block-time">
              <div class="block__number">
                <ICountUp :endVal="showBlockTime" :options="timeOptions" @ready="blockTimeReady" />
              </div>
              <span class="block__title">Block Time</span>
            </div>
            <div class="block tps">
              <div class="block__number">
              <ICountUp :endVal="showTps" :options="TpsOptions" @ready="blockTpsReady" />
              </div>
              <span class="block__title">TPS</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="about__content01">
      <div class="content01">
        <v-btn v-for="(item, index) in contentList" :key="index" @mouseover="cursorBox = item.title"
        class="content-box"
        :class="[ cursorBox === `${item.title}` ? `${item.title}` : '', `toch${item.title}` ]"
        target="_blank"
        :href="item.link"
        >
          <p class="content-box__title">{{ item.title }}</p>
          <div class="content-box__line"></div>
          <p class="content-box__info">{{ item.info }}
          </p>
          <!-- <img class="content-box__icon" src="@/assets/media/Icon/Content_Next.png" alt="content next icon"> -->
        </v-btn>
      </div>
    </section>
    <section class="about__content02">
      <div class="content02">
        <div class="content02__info">
          <p class="content02__info--first">Cross-chain Mainnet</p>
          <p class="content02__info--sub">
            MEVerse connects with other mainnet networks and enhances
            interoperability with its quality technology.
          </p>
          <img src="@/assets/media/Content/Home_Network.svg" alt="network image">
        </div>
        <div class="content02__banner"></div>
      </div>
    </section>
    <section class="about__content03">
      <div class="content03">
        <p class="content03__title">MEVerse Core</p>
        <ul class="content03__list">
          <li v-for="(tab, index) in coreTabList" :key="index" :class="`${tab.title}`" class="content03__list--tab">
            <div @click="tab.class = !tab.class" :class="{ coreTabActive: tab.class }" class="tab-btn">
              <p>{{ tab.title }}</p>
            </div>
            <v-expand-transition>
              <div v-if="tab.class" class="tab-box">
                <p>{{ tab.content }}</p>
              </div>
            </v-expand-transition>
          </li>
        </ul>
      </div>
    </section>
    <section class="about__content04">
      <div class="content04">
        <v-btn class="content-box" target="_blank" :href="`https://t.me/MEVerse_EN`">
          <p class="content-box--first">Join the Community</p>
          <p class="content-box--sub">
            MEVerse is ready to communicate with you!<br class="break" />
            If you have any questions regarding MEVerse, please feel<br class="break" />
            free to join!
          </p>
          <img class="content-box--icon" src="@/assets/media/Icon/Content_Next.png" alt="content next icon">
        </v-btn>
        <v-btn class="content-box" target="_blank" :href="`mailto:${emailId}`">
          <p class="content-box--first">Enterprise Solution</p>
          <p class="content-box--sub">
            Utilize MEVerse to create your own Metaverse.
          </p>
          <img class="content-box--icon" src="@/assets/media/Icon/Content_Next.png" alt="content next icon">
        </v-btn>
      </div>
    </section>
    <partners-line />

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2';
import PartnersLine from '../components/PartnersLine.vue';
export default {
  name: 'About',
  data() {
    return {
      checked: false,
      cursorBox: 'Entertainment',
      contentList: [
        {
          title: 'Entertainment',
          link: ``,
          info: `Welcome to MEVerse, where
            blockchain game and metaverse are
            harmonized. MEVerse's various
            games include metaverse games,
            and the users can have new
            experiences when playing them.
            Stay fun with MEVerse!`
        },
        {
          title: 'DeFi',
          link: ``,
          info: `Defi services generate continuous transactions and enable various assets to be utilized. MEVerse mainnet can process up to 9k transactions per second with such low fee.`,
        },
        {
          title: 'MApp',
          link: ``,
          info: `Regardless of the industry, MApps(Metaverse, MEVerse DApp) can provide excellent performance services and create various business models in MEVerse ecosystem.`,
        }
      ],
      coreTabList: [
        {
          title: 'Consensus Algorithm: PoF',
          content: 'PoF(Proof of Formulation) is a new consensus model designed by MEVerse. Unlike other consensus such as PoW, PoF is environment-friendly-fair-efficient consensus algorithm with real time confirmation.',
          class: false
        },
        {
          title: 'Customizable Multi Chain',
          content: 'In MEVerse platform, MApps can choose to either have their separate chain to operate independently or join the MEVerse public chain to fully enjoy ecosystem services.',
          class: false
        },
        {
          title: 'Level Tree Validation',
          content: 'Merkle Tree has an inefficient computational structure, so MEVerse developed a Level Tree validation which enabled parallel processing.',
          class: false
        },
        {
          title: 'Block Redesign',
          content: 'MEVerse redesigned the block structure to reduce blocksize, increase processing speed and reducing index volume needed for faster operation.',
          class: false
        },
      ],
      options: {
        startVal: 0,
        userEasing: true,
        useGrouping: true,
        separator: ',',
        deciaml: '.',
      },
      timeOptions: {
        startVal: 0,
        userEasing: true,
        useGrouping: true,
        duration: 5,
        decimalPlaces: 1,
        deciaml: '.',
        suffix: 's',
      },
      TpsOptions: {
        startVal: 0,
        userEasing: true,
        useGrouping: true,
        separator: ',',
        deciaml: '.',
      },
      showBlockTime: 0.5,
      showTps: 9000,
      emailId: 'hello@meverselabs.io',
      initBlockNumber: 0,
      perBlock: 2,
      intervalId_init: 0,
      intervalId_count: 0,
    }
  },
  components: {
    ICountUp,
    PartnersLine
  },
  mounted() {
    this.initBlockHeight();
  },
  methods: {
    getBlockHeightAPI() {
      fetch(`https://rpc.meversemainnet.io`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          jsonrpc: "2.0",
          method: "view.blockNumber",
          params: [],
          id: "07df3e2f-86fc-4f45-911a-bb084053c412",
        }),
      })
      .then((res) => {
        if (res.status >= 200 && res.status <= 299) {
          return res.json().then(data => {
            if (!data.result) return 0;
            this.initBlockNumber = data.result;
            // console.log('initBlockNumber: ',this.initBlockNumber)
          })
        }
        throw new Error("Network Error", JSON.stringify(res));
      })
    },
    initBlockHeight() {
      this.getBlockHeightAPI();
      this.setIntervalBlock();
      this.addBlockPerSecond();
    },
    addBlockPerSecond() {
      setInterval(() => {
        this.initBlockNumber += this.perBlock;
      }, 1000);
    },
    setIntervalBlock() {
      this.intervalId_init = setInterval(() => {
        // console.log('start!')
        this.getBlockHeightAPI();
      }, 10000);
    },
    blockHeightReady(instance) {
      instance.update(this.initBlockNumber);
    },
    blockTimeReady(instance) {
      instance.update(this.showBlockTime);
    },
    blockTpsReady(instance) {
      instance.update(this.showTps);
    },
    beforeDestroy() {
      clearInterval(this.intervalId_init);
      clearInterval(this.intervalId_count);
    },
  },
}
</script>